module.exports = __webpack_public_path__ + "assets/img/632600.da5f8bc2.png";